/** Stable error codes returned by the API as { error: { code, message, details? } }. UI maps codes to i18n keys. */
export const ERROR_CODES = [
  'bad_request',
  'validation_failed',
  'unauthorized',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'csrf_failed',
  'internal',
  // auth
  'otp_invalid',
  'otp_expired',
  'otp_too_many_attempts',
  'captcha_failed',
  'handle_taken',
  // eligibility
  'paid_not_eligible',
  'underage',
  'self_excluded',
  'account_banned',
  'account_suspended',
  // rooms / matchmaking
  'already_in_queue',
  'already_in_match',
  'room_not_open',
  'room_is_yours',
  'stake_not_allowed',
  'opponent_not_allowed',
  'pair_limit_reached',
  'no_game_server',
  'match_not_found',
  'rematch_unavailable',
  // money
  'insufficient_funds',
  'amount_out_of_range',
  'deposit_limit_reached',
  'withdrawal_pending_exists',
  'withdrawal_not_allowed',
  'pix_key_not_owned',
  'idempotency_conflict',
  'provider_unavailable',
  // internal
  'bad_signature',
  'stale_request',
  'replayed_request',
  'lease_mismatch',
  'result_conflict',
  // cosmetics store
  'cosmetic_not_available',
  'cosmetic_already_owned',
  'cosmetic_sold_out',
  'cosmetic_not_owned',
  'purchase_not_allowed',
  'refund_not_allowed',
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export interface ApiErrorBody {
  error: { code: ErrorCode; message: string; details?: unknown };
}
